<template>
  <p-button
    class="ml-2 menu-button p-button-rounded p-button-secondary social-button mobile-menu"
    icon="pi pi-bars"
    type="button"
    @click="toggleMenu"
  />
  <SideDrawer
    v-model:visible="showMenu"
    class="drawer"
    dark-background
    max-width="390px"
  >
    <template #content>
      <div class="header">
        <span class="title">{{ $t('common.menu') }}</span>
        <div class="settings">
          <PButton class="button" @click="showNotifiCard">
            <img src="@/assets/notifi-bell-icon.svg" />
          </PButton>
          <PButton
            class="button"
            icon="pi pi-times"
            @click="showMenu = false"
          />
        </div>
      </div>
      <hr v-if="isReferralBlockDisplay" class="divider" />
      <ReferralId v-if="isReferralBlockDisplay" />
      <hr class="divider" />
      <div class="sub-title">{{ $t('swap.swap') }}</div>

      <p-menu ref="menu" :model="topList" :popup="false" class="mobile-menu">
        <template #item="{ item }">
          <a
            v-if="item.name === 'concentrated liquidity'"
            :href="item.url"
            class="p-menuitem-link"
            rel="noreferrer noopenner"
            @click="track(EMixpanelEventNames.ConcentratedLiquidityClick)"
          >
            <span
              v-if="item.icon"
              :class="item.icon"
              class="p-menuitem-icon"
            ></span>
            Concentrated Liquidity
          </a>
          <a
            v-if="item.name === 'kana'"
            :href="item.url"
            class="p-menuitem-link"
            rel="noreferrer noopenner"
            @click="track(EMixpanelEventNames.SwapKanaButtonClicked)"
          >
            <span
              v-if="item.icon"
              :class="item.icon"
              class="p-menuitem-icon"
            ></span>
            {{ $t('header.kana') }}
          </a>
          <Accordion
            v-else-if="haveBuyAptUrls && item.name === 'buy-apt'"
            class="buy-apt-accordion"
            lazy
          >
            <AccordionTab>
              <template #header>
                <div class="buy-apt-wrapper" @click="onClickBuyAptRow">
                  <img
                    alt="APT logo"
                    class="p-menuitem-icon"
                    src="@/assets/tokens/apt.svg"
                    width="24"
                  />
                  {{ $t('header.buyAPT') }}
                  <div class="flex ml-auto p-0">
                    <img
                      alt="APT logo"
                      class="p-menuitem-icon buy-apt-icon"
                      src="@/assets/payment/master-card-logo.svg"
                      width="24"
                    />
                    <img
                      alt="APT logo"
                      class="p-menuitem-icon ml-2 buy-apt-icon"
                      src="@/assets/payment/visa-logo.svg"
                      width="34"
                    />
                  </div>
                </div>
              </template>
              <template
                v-for="(
                  { targetImg, title, description, url, type, fee }, index
                ) in buyAptMenuItems"
                :key="index"
              >
                <BuyAptCard
                  :description="description"
                  :fee="fee"
                  :img-path="targetImg"
                  :is-link="type === 'moonpay' || type === 'coinbase'"
                  :target-url="url"
                  :title="title"
                  @click="onBuyAptClick(type)"
                />
                <hr class="divider" />
              </template>
            </AccordionTab>
          </Accordion>
          <!-- this condition is necessary because of the previous complex condition -->
          <template v-else-if="item.name !== 'buy-apt'">
            <router-link
              :class="{ active: route.name === item.name }"
              :to="{ name: item.name }"
              class="p-menuitem-link"
              @click="
                () => {
                  if (item.command) item.command();
                  showMenu = false;
                }
              "
            >
              <span
                v-if="item.icon"
                :class="item.icon"
                class="p-menuitem-icon"
              ></span>
              {{ item.label }}
              <img
                v-if="item.name === 'stakes'"
                class="stakes-icon ml-2"
                src="@/assets/hydroponics.svg"
              />
            </router-link>
          </template>
        </template>
      </p-menu>
      <div v-if="!isMovement" class="sub-title">{{ $t('header.bridge') }}</div>
      <p-menu
        v-if="!isMovement"
        ref="menu"
        :model="bridgeList"
        :popup="false"
        class="mobile-menu"
      >
        <template #item="{ item }">
          <a
            v-if="item.url"
            :href="item.url"
            class="p-menuitem-link"
            role="menuitem"
            tabindex="0"
            rel="noreferrer noopener"
            @click="onClickMoreListItem(item)"
          >
            <span :class="item.icon" class="p-menuitem-icon"></span>
            <span class="p-menuitem-text">{{ item.label }}</span>
          </a>
          <router-link
            v-else
            :class="{ active: route.name === item.name }"
            :to="{ name: item.name }"
            class="p-menuitem-link"
            @click="onClickEarnListItem(item as TMenuItem)"
          >
            <span
              v-if="item.icon"
              :class="item.icon"
              class="p-menuitem-icon"
            ></span>
            {{ item.label }}
          </router-link>
        </template>
      </p-menu>
      <div class="sub-title">{{ $t('header.earn') }}</div>
      <p-menu ref="menu" :model="earnList" :popup="false" class="mobile-menu">
        <template #item="{ item }">
          <router-link
            :class="{ active: route.name === item.name }"
            :to="{ name: item.name }"
            class="p-menuitem-link"
            @click="onClickEarnListItem(item as TMenuItem)"
          >
            <span
              v-if="item.icon"
              :class="item.icon"
              class="p-menuitem-icon"
            ></span>
            {{ item.label }}
          </router-link>
        </template>
      </p-menu>
      <div v-if="!isL2 && !isMovement" class="sub-title">
        {{ $t('header.analytics') }}
      </div>
      <p-menu
        v-if="!isL2 && !isMovement"
        ref="menu"
        :model="[
          {
            label: 'Stats',
            name: 'stats',
            icon: 'menu-link menu-link_type_stats',
            to: { name: 'stats' },
          },
        ]"
        :popup="false"
        class="mobile-menu"
      >
        <template #item="{ item }">
          <router-link
            :class="{ active: route.name === item.name }"
            :to="{ name: item.name }"
            class="p-menuitem-link"
            @click="
              () => {
                if (item.command) item.command();
                track(EMixpanelEventNames.StatClicked);
                showMenu = false;
              }
            "
          >
            <span
              v-if="item.icon"
              :class="item.icon"
              class="p-menuitem-icon"
            ></span>
            {{ item.label }}
          </router-link>
        </template>
      </p-menu>
      <div class="sub-title">{{ $t('header.more') }}</div>
      <p-menu ref="menu" :model="moreList" :popup="false" class="mobile-menu">
        <template #item="{ item }">
          <a
            v-if="item.url"
            :href="item.url"
            class="p-menuitem-link"
            rel="noreferrer noopener"
            role="menuitem"
            tabindex="0"
            target="_blank"
            @click="onClickMoreListItem(item)"
          >
            <span :class="item.icon" class="p-menuitem-icon"></span>
            <span class="p-menuitem-text">{{ item.label }}</span>
          </a>
          <router-link
            v-else
            :class="{ active: route.name === item.name }"
            :to="{ name: item.name }"
            class="p-menuitem-link"
            @click="onClickMoreListItem(item)"
          >
            <span v-if="item.icon" :class="item.icon" class="p-menuitem-icon" />
            {{ item.label }}
          </router-link>
        </template>
      </p-menu>
      <div class="network-section">
        <div class="sub-title">Network</div>
        <NetworkSwitch :is-lumio="isL2" :is-mobile-menu="true" />
      </div>
      <template v-if="isWalletConnected">
        <div class="sub-title">{{ $t('common.wallet') }}</div>
        <p-menu
          ref="menu"
          :model="walletActionList"
          :popup="false"
          class="mobile-menu"
        >
          <template #item="{ item }">
            <a
              class="p-menuitem-link"
              role="menuitem"
              tabindex="0"
              @click="
                () => {
                  if (item.command) item.command();
                  showMenu = false;
                }
              "
            >
              <span :class="item.icon" class="p-menuitem-icon"></span>
              <span class="p-menuitem-text">{{ item.label }}</span>
            </a>
          </template>
        </p-menu>
      </template>
    </template></SideDrawer
  >
</template>

<script lang="ts" setup>
import { computed, inject, ref } from 'vue';
import { RouteRecordName, RouterLink, useRoute } from 'vue-router';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import BuyAptCard from '@/components/CommonHeader/BuyAptCard.vue';
import { SideDrawer } from '@/components/UI/SideDrawer';
import {
  buyAptMenuItems,
  handlePurchaseByTransak,
  haveBuyAptUrls,
  TPaymentBrand,
} from '@/composables/usePaymentMenuService';
import { useI18n } from '@/composables/useI18n';
import {
  AVAILABLE_FUNCTIONS,
  ChainsEnum,
  CL_URL,
  CORRECT_CHAIN,
  FARM_URL,
  PAGE_NAMES_WITH_ONBOARDING,
} from '@/constants';
import { useStore } from '@/store';
import { showRequestTokenDialog } from '@/composables/useDialogService';
import { useDialog } from 'primevue/usedialog';
import { EMixpanelEventNames, EMixpanelProvideKeys } from '@/types/enums';
import { ReferralId } from '@/components/CommonHeader/ReferralId';
import { NetworkSwitch } from 'ls-ui';
import { useWalletPlugin } from '@/composables/useWalletPlugin';

const { t } = useI18n();

const mainStore = useStore();
const showMenu = ref(false);
const route = useRoute();

const isL2 = computed(() => CORRECT_CHAIN.id === ChainsEnum['lumio-testnet']);
const isMovement = computed(() =>
  [ChainsEnum['movement-testnet'], ChainsEnum['movement-mainnet']].includes(
    CORRECT_CHAIN.id,
  ),
);

//TODO: need to refactor. Now it is necessary to prevent tracking of the event when clicking on "buy apt" again
const isBuyAptOpen = ref(false);

const track: any = inject(EMixpanelProvideKeys.Track);

const { account, disconnect } = useWalletPlugin();

const toggleMenu = () => {
  showMenu.value = !showMenu.value;

  //reset the state when interact with sidebar
  isBuyAptOpen.value = false;
};

const restoreOnBoarding = (value: boolean) => {
  track(EMixpanelEventNames.OnboardingClicked);
  mainStore.showOnBoarding.value = value;
};

type TMenuItem = {
  label: string;
  icon?: string;
  name?: string;
  url?: string;
  target?: string | null;
  to?: { name: string };
  command?: () => void;
};

const earnList = ref<TMenuItem[]>([
  {
    label: t('header.pools'),
    name: 'pools',
    icon: 'menu-link menu-link_type_pools',
    to: { name: 'pools' },
  },
]);

const bridgeList = ref<TMenuItem[]>([
  {
    label: 'LayerZero',
    name: 'wormhole-bridge',
    icon: 'menu-link menu-link_type_layerzero',
    url: 'https://bridge.liquidswap.com',
  },
  {
    label: 'Wormhole',
    name: 'wormhole-bridge',
    icon: 'menu-link menu-link_type_wormhole',
    url: 'https://bridge.liquidswap.com/wormhole-widget',
  },
]);

const topList = ref<TMenuItem[]>([
  {
    label: t('swap.swap'),
    name: 'swap',
    icon: 'menu-link menu-link_type_swap',
    to: { name: 'swap' },
  },
]);

const moreList = computed(() => {
  const items = [
    {
      icon: 'menu-link menu-link_type_dashboard',
      label: t('common.dashboard'),
      name: 'dashboard',
      to: { name: 'dashboard' },
    },
    {
      icon: 'pi pi-info-circle',
      label: t('header.learnMore'),
      name: 'learn more',
      url: isL2.value ? 'https://lumio.io/' : 'https://home.liquidswap.com/',
    },
    !isMovement.value && {
      icon: 'pi pi-plus-circle',
      label: t('header.createToken'),
      name: 'token-generation',
      to: { name: 'token-generation' },
    },
  ].filter(Boolean) as TMenuItem[];

  const needDisplayOnboardingItem =
    mainStore.showOnBoarding.value === false &&
    PAGE_NAMES_WITH_ONBOARDING.includes(route.name as RouteRecordName);

  if (needDisplayOnboardingItem) {
    items.push({
      icon: 'onboarding-icon',
      label: t('header.onboarding'),
      url: undefined,
      target: null,
      command: () => restoreOnBoarding(true),
    });
  }

  items.push({
    icon: 'pi pi-book',
    label: t('header.docs'),
    url: 'https://docs.liquidswap.com',
  });

  return items;
});

const walletActionList = ref([
  {
    icon: 'pi pi-power-off',
    label: t('common.disconnect'),
    command: async () => {
      await disconnect();
    },
  },
]);

if (
  ![ChainsEnum['aptos-testnet'], ChainsEnum['lumio-testnet']].includes(
    CORRECT_CHAIN.id,
  )
) {
  topList.value.push({
    label: t('common.concentratedLiquidity'),
    name: 'concentrated liquidity',
    icon: 'menu-link menu-link_type_cl',
    url: CL_URL,
  });

  topList.value.push({
    label: t('header.bridge'),
    name: 'bridge',
    icon: 'menu-link menu-link_type_bridge',
    url: 'https://bridge.liquidswap.com',
  });
}

if (!isMovement.value) {
  topList.value.push({
    label: t('header.buyAPT'),
    name: 'buy-apt',
  });
}

if (CORRECT_CHAIN.id !== ChainsEnum['lumio-testnet']) {
  if (!isMovement.value) {
    earnList.value.push({
      label: t('header.farms'),
      icon: 'menu-link menu-link_type_stakes',
      command: () => {
        window.open(FARM_URL, '_self', 'noopener,noreferrer');
      },
    });
  }

  if (AVAILABLE_FUNCTIONS.APTOS_STAKING && !isMovement.value) {
    earnList.value.push({
      label: t('header.staking'),
      name: 'aptos-staking',
      icon: 'menu-link menu-link_type_staking',
      to: { name: 'aptos-staking' },
    });
  }

  if (AVAILABLE_FUNCTIONS.SOLO) {
    earnList.value.push({
      label: t('Single-Token Deposits'),
      name: 'poolsSolo',
      to: { name: 'poolsSolo' },
      icon: 'dropdown-link dropdown-link_type_solo',
    });
  }
}

if (CORRECT_CHAIN.id === ChainsEnum['aptos-testnet']) {
  earnList.value.push({
    label: t('header.aptosFaucet'),
    command: () => onRequestTokens(),
  });
  moreList.value.push({
    icon: 'pi pi-money-bill',
    label: t('header.mainnet'),
    url: 'https://liquidswap.com',
  });
}

if (CORRECT_CHAIN.id === ChainsEnum['lumio-testnet']) {
  earnList.value.push({
    label: t('header.faucet'),
    command: () => onRequestTokens(),
  });
}

moreList.value = moreList.value.concat(
  {
    icon: 'pi pi-discord',
    label: t('header.discord'),
    url: 'https://discord.com/invite/44QgPFHYqs',
  },
  {
    icon: 'pi pi-comments',
    label: t('header.feedbackForPartners'),
    url: 'https://form.typeform.com/to/ggYvlrgj',
  },
  {
    icon: 'pi pi-telegram',
    label: t('header.telegramCommunity'),
    url: 'https://t.me/pontemnetworkchat',
  },
);

const isWalletConnected = computed(() => !!account?.value?.address);
const isReferralBlockDisplay = computed(
  () => mainStore.account.value?.address && !isMovement.value,
);

const dialog = useDialog();
function onRequestTokens() {
  showRequestTokenDialog(dialog);
}

function showNotifiCard() {
  mainStore.showDialog('notifiCard');
  showMenu.value = false;
}

function onBuyAptClick(type: TPaymentBrand) {
  trackMixpanel(type);

  if (type === 'moonpay' || type === 'coinbase') return;
  toggleMenu();
  handlePurchaseByTransak(account.value.address as string);
}

function onClickBuyAptRow() {
  isBuyAptOpen.value = !isBuyAptOpen.value;
  if (isBuyAptOpen.value) {
    track(EMixpanelEventNames.BuyAptClicked);
  }
}

function onClickMoreListItem(item: any) {
  if (item.name === 'learn more') {
    track(EMixpanelEventNames.LearnMoreClicked);
  }

  if (item.command) item.command();
  showMenu.value = false;
}

function onClickEarnListItem(item: TMenuItem) {
  if (item.command) item.command();
  if (item.name) trackMixpanelByItemName(item.name);
  showMenu.value = false;
}

function trackMixpanelByItemName(name: string) {
  switch (name) {
    case 'stakes':
      track(EMixpanelEventNames.FarmClicked);
      break;
    case 'aptos-staking':
      track(EMixpanelEventNames.StakingClicked);
      break;
    default:
      break;
  }
}

function trackMixpanel(type: TPaymentBrand) {
  switch (type) {
    case 'coinbase':
      track(EMixpanelEventNames.StartCoinbase);
      break;
    case 'moonpay':
      track(EMixpanelEventNames.StartMoonpay);
      break;
    case 'transak':
      track(EMixpanelEventNames.StartTransak);
      break;
    default:
      break;
  }
}
</script>
<style lang="scss">
.mobile-menu {
  &.p-menu {
    background-color: #16162d !important;
    width: auto;
    border: 0px;
    border-radius: 0;
    margin: 0rem -1.25rem;
    padding: 0px;

    .p-menuitem {
      &:not(:last-child) {
        border-bottom: 1px solid #e5e4fa1a;
      }

      .p-menuitem-link,
      .p-accordion-header-link {
        padding: 20px 24px 20px 20px;

        font-size: 20px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: -0.45%;

        &.active,
        &:hover {
          background-color: #2b2b40 !important;
        }

        &:focus {
          box-shadow: none !important;
        }

        & .p-menuitem-icon {
          width: 24px;
          height: 24px;
          margin-right: 20px;

          font-size: 24px;
          color: #d4c4ed;
        }

        & .buy-apt-icon {
          width: auto !important;
          height: 18px !important;
          margin-right: 0 !important;
        }
      }
      .buy-apt-card__component {
        padding: 12px 20px;
      }
      .buy-apt-accordion {
        padding: 0;
      }
      .active {
        background-color: rgba(255, 255, 255, 0.03);
      }
    }
  }

  .p-menuitem {
    padding: 0px 16px;
  }

  .p-toggleable-content {
    border-top: 1px solid #e5e4fa1a;
  }
}
</style>
<style lang="scss" scoped>
.buy-apt-accordion {
  &:deep(.p-accordion-tab) {
    margin-bottom: 0;
  }
}

:deep(.p-accordion-header) {
  padding: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;

  &:not(.p-disabled) {
    &.p-highlight {
      .p-accordion-header-link {
        background: none;
        &:focus {
          box-shadow: 0 0 0 0.15rem rgb(196 181 253 / 50%);
        }
      }
    }

    & .p-accordion-header-link {
      background: none;
      &:focus {
        box-shadow: 0 0 0 0.15rem rgb(196 181 253 / 50%);
      }
    }
  }

  .p-accordion-header-link {
    background: none;
    border: none;
    font-weight: 400;
  }

  .p-accordion-toggle-icon {
    display: none;
  }
}

:deep(.p-accordion-content) {
  padding: 0px;
  background-color: #16162d;
}

.sub-title {
  padding: 8px 20px;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.44px;
  color: #e5e4fa;
  background-color: #03031c;
}

.divider {
  border: 0px;
  border-top: 2px solid #fbfaff16;
  border-width: 2px 0px 0px 0px;
  margin: 0px -1.25rem;
}
.header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.5rem;

  .title {
    font-weight: 800;
    font-size: 20px;
    line-height: 25px;
    letter-spacing: -0.45%;
    color: #e5e4fa;
  }

  & > div:last-child {
    margin-left: auto;
  }
}

.settings {
  display: flex;
  flex-direction: row;
  column-gap: 0.5rem;
  .button {
    justify-content: center;

    width: 48px;
    height: 48px;
    padding: 0.5rem;

    border: none;
    border-radius: 13px;
    background-color: #24243a;

    &:hover {
      color: white;
    }

    & img,
    & .pi {
      width: 1.2rem;
    }
  }
}

.menu-link {
  width: 24px;
  height: 24px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;

  &_type_swap {
    background-image: url('@/assets/swap-wide.svg');
  }

  &_type_pools {
    background-image: url('@/assets/pools.svg');
  }

  &_type_stats {
    background-image: url('@/assets/stats.svg');
  }

  &_type_bridge {
    background-image: url('@/assets/bridge.svg');
  }

  &_type_stakes {
    background-image: url('@/assets/farms.svg');
  }

  &_type_solo {
    background-image: url('@/assets/pools-solo.svg');
  }

  &_type_staking {
    background-image: url('@/assets/staking.svg');
  }

  &_type_claim {
    background-image: url('@/assets/claim.svg');
  }

  &_type_cl {
    background-image: url('@/assets/concentrated-liquidity.svg');
  }

  &_type_dashboard {
    background-image: url('@/assets/dashboard.svg');
  }

  &_type_kana-swap {
    background-image: url('@/assets/kana-swap.svg');
  }

  &_type_layerzero {
    background-image: url('@/assets/layerzero-header.svg');
  }

  &_type_wormhole {
    background-image: url('@/assets/wormhole-header.svg');
  }
}

.buy-apt-wrapper {
  width: 100%;
  display: flex;
}
.network-section {
  @media screen and (min-width: 390px) {
    display: none;
  }
}
</style>
